import { Instance, SnapshotIn, types } from 'mobx-state-tree';

export type TProductOptionChoiceDetails = typeof ProductOptionChoiceDetailsModel;
export type ProductOptionChoiceDetailsInstance = Instance<TProductOptionChoiceDetails>;
export interface IProductOptionChoiceDetailsIn extends SnapshotIn<TProductOptionChoiceDetails> {}
export interface IProductOptionChoiceDetailsInstance extends ProductOptionChoiceDetailsInstance {}

export const ProductOptionChoiceDetailsModel = types
  .model({
    color: types.maybe(types.string),
  })
  .views(self => ({}))
  .actions(self => ({
    updateColor(color: string) {
      self.color = color;
    },
  }));
